import React, {} from "react"

const paths = require('../../../paths.json');

export default function UpgradeSubscription(influencer, upgrade_tier, page, duration) {
    const form_data = new FormData()
    form_data.append('upgrade_tier', upgrade_tier)
    form_data.append('influencer', influencer)
    form_data.append('duration', duration)
    if (page === 'home'){
      this.get_and_post_data_skeleton(
         paths.BACKEND_URL + "api/settings_post_processing/",
         "post",
         false,
         form_data,
         this.UpgradeProcessPost,
      )
   } else if (page === 'my_subs'){
      this.get_and_post_data_skeleton(
         paths.BACKEND_URL + "api/settings_post_processing/",
         "post",
         false,
         form_data,
         this.UpgradeProcessPost,
      )
   } else if (page === 'influencer'){
      this.get_and_post_data_skeleton(
         paths.BACKEND_URL + "api/settings_post_processing/",
         "post",
         false,
         form_data,
         this.UpgradeProcessPost,
      )
   } else if (page === 'content'){
      this.get_and_post_data_skeleton(
         paths.BACKEND_URL + "api/settings_post_processing/",
         "post",
         false,
         form_data,
         this.UpgradeProcessPost,
      )
   }
}
